<template>
    <div>
        <ArboNode
            class="p-2"
            :menu="menu"
            :selected-menu-id="selectedMenuId"
            :template-config="templateConfig"
            @select="select"
        />
    </div>
</template>

<script>
import ArboNode from "./ArboNode.vue";
export default {
    components: {
        ArboNode,
    },

    props: {
        arbo: Array,
        templateConfig: Array,
        selectedMenuId: [String, Number],
    },

    computed: {
        menu() {
            return {
                children: this.arbo,
            };
        },
    },

    methods: {
        select(data) {
            this.$emit("select", data);
        },
    },
};
</script>
